import { toDayJs } from '@helpers'

const hasEventExpired = (endDate, hoursOffset = 0) => {
  return toDayJs().diff(toDayJs(endDate), 'hours') >= hoursOffset
}

export default hasEventExpired
